import Vue from 'vue'
import Notifications from 'vue-notification'
import VueMeta from 'vue-meta'

import router from '@/router'

import App from './App.vue'

Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

new Vue({
  data() {
    return {
      width: null
    }
  },
  mounted() {
    this.addListeners()
  },
  methods: {
    addListeners() {
      window.addEventListener('resize', this.onResize)
    },
    onResize() {
      this.width = window.innerWidth
    }
  },
  router,
  render: h => h(App)
}).$mount('#app')
